import { render, staticRenderFns } from "./index.vue?vue&type=template&id=99ec2840&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "../../style.scss?vue&type=style&index=0&id=99ec2840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ec2840",
  null
  
)

export default component.exports